import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore'
import FontAwesome from 'react-fontawesome';

class PrintTwoPagesDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      data:{company_name:'',company_tax:'',customer_name:''},
      dataList:[],
      defaultTypePrint:'3'
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
  	this.loadData(this.props.doc,this.props.param)
  }

  newEmptyRow(number=1) {
    let {doc} = this.props
    let row = {}
    if (doc==='invoice_doc')
      row = {bf_invoice_item_id:'', invoice_no:'', amount: '',detail: '',discount: '', price_per_unit: '', quantity:'', seq: undefined}
    else if (doc==='purchase_received_doc')
      row = {bf_purchase_order_item_id:'', purchase_order_no:'', amount: '',detail: '',discount: '', price_per_unit: '', quantity:'', seq: undefined}
    else if (doc==='receipt_doc')
      row = {bf_receipt_item_id:'', receipt_no:'', amount: '',detail: '',discount: '', price_per_unit: '', quantity:'', seq: undefined}
    else if (doc==='taxinvoice_doc')  
      row = {bf_taxinvoice_item_id:'', taxinvoice_no:'', amount: '',detail: '',discount: '', price_per_unit: '', quantity:'', seq: undefined}
    
    return new Array(number).fill(null).map((item,index)=>{
      return row
    }) 
  }

  loadData(url,param) {
    PdfStore.loadTwoPageDoc(url,param,this.props.docNo,(result)=> {
    	this.setState({data:result.data})

      let dataList = []
      let _length = 0
      if (this.props.doc==='purchase_received_doc') {
        dataList = result.data.item
        _length = result.data.item.length
      } else {
        dataList = result.data.itemlist
        _length = result.data.itemlist.length
      }
    	
      if (_length<15) {
    		let round = 15 - _length
        if (dataList.length>0)
          dataList = dataList.concat(this.newEmptyRow(round))
        else
          dataList = this.newEmptyRow(round)

    	}
    	this.setState({dataList:dataList})
    })
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderRowData() {
    let {dataList} = this.state
    let {doc} = this.props
    return(
    	dataList.map((item,index) => { 
    		let hr_b_none = (doc==='purchase_received_doc'?'':'hr-b-none')
    		if (dataList.length-1===index)
    			hr_b_none = ''

    		return(
		    	<tr key={index}>
		    		<td className={hr_b_none+' print-font-16 text-center'}>{item.seq!==undefined?index+1:<br/>}</td>
		    		<td className={hr_b_none+' print-font-16'}>{item.detail}</td>
		    		<td className={hr_b_none+' print-font-16 text-center'}>{item.quantity}</td>
		    		<td className={hr_b_none+' print-font-16 text-right'}>{this.getNumberFormat(item.price_per_unit)}</td>
		    		<td className={hr_b_none+' print-font-16 text-right'}>{this.getNumberFormat(item.amount)}</td>
		    	</tr>
		    )
		})    	
    )
  }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    return ''
  }

  getVat(sum_amount) {
    let {data} = this.state
  	let vat = 0
    
    if (data.vat_type!=='NON_VAT')
  	  vat = (sum_amount*7)/100

  	return vat
  }

  getNetTotal(sum_amount,vat) {
  	let net_total = 0
  	net_total = parseFloat(sum_amount)+parseFloat(vat)
  	return net_total
  }

  renderFooter() {
    let {data} = this.state
    let {doc} = this.props
    let sum_amount = 0
   	
   	if (data.itemlist!==undefined&&data.itemlist.length>0) {
	    data.itemlist.forEach(function(item,index) {
	      let amount = item.amount  
	      if (amount===''||amount===null||amount===undefined||isNaN(amount))
	        amount = 0

	      sum_amount += parseFloat(amount)
	    })
    }
    
    let rowSpan = doc==='cashbill_doc'?2:3
    let hideVat = doc==='cashbill_doc'?' hide':''

    return([
    	   <tr key={0} >
        	<td style={{verticalAlign:'middle'}} rowSpan={rowSpan} colSpan={2} className={'print-font-16 text-center '}>{data.grand_total_thai}</td>
        	<td className={'print-font-16 '+hideVat} colSpan={2}>{doc==='purchase_received_doc'?'รวมเงิน':'Total Price/ราคารวม'}</td>
        	<td className={'print-font-16 text-right '+hideVat}>{this.getNumberFormat(sum_amount)}</td>
      	</tr>,
      	<tr key={1} className={hideVat}>
        	<td className='print-font-16' colSpan={2}>{doc==='purchase_received_doc'?'ภาษีมูลค่าเพิ่ม 7%':'Vat/ภาษีมูลค่าเพิ่ม 7%'}</td>
        	<td className='print-font-16 text-right'>{this.getNumberFormat(this.getVat(sum_amount))}</td>
      	</tr>,
      	<tr key={2}>
        	<td className='print-font-16' colSpan={2}>{doc==='purchase_received_doc'?'ราคาสุทธิ':'Net Price/ราคาสุทธิ'}</td>
        	<td className='print-font-16 text-right'>{this.getNumberFormat(this.getNetTotal(sum_amount,this.getVat(sum_amount)))}</td>
      	</tr>
   	])
  }

  _renderSignature() {
    let {doc} = this.props
    return(
        <td colSpan={2} className={'print-font-16 text-center'+(doc==='purchase_received_doc'?' hr-b-none':'')}>
          <br/>
          ..................................................................
          <br/>
          {doc==='purchase_received_doc'?'ผู้สั่งซื้อ':'ผู้ชำระเงิน'}
        </td>
    )
  }

  renderSignature() {
    let {doc} = this.props
    return(
      <tr>
      	<td colSpan={2}></td>
      	<td colSpan={3} className={'print-font-16 text-center'+(doc==='purchase_received_doc'?' hr-b-none':'')}>
      		<br/>
      		..................................................................
      		<br/>
      		{doc==='purchase_received_doc'?'ผู้อนุมัติ':'ผู้มีอำนาจลงนาม'}
      	</td>
      </tr>
    )
  }

  renderSignatureDate() {
    return(
      <tr>
        <td colSpan={2} className='print-font-16 text-center'>
          วันที่ / Date.........................
        </td>
        <td colSpan={3} className='print-font-16 text-center'>
          วันที่ / Date.........................
        </td>
      </tr>
    )
  }

  renderTable(item,index) {
    let {doc} = this.props
    return(
      <div className=''>
        <table className='table table-print-po-received-doc'>
          <tbody>
            <tr>
              <td className='print-font-16 text-center' style={{width:'50px'}}>ลำดับ</td>
              <td className='print-font-16 text-center' style={{width:'300px'}}>รายการ</td>
              <td className='print-font-16 text-center' style={{width:'70px'}}>จำนวน</td>
              <td className='print-font-16 text-center' style={{width:'100px'}}>ราคา/หน่วย</td>
              <td className='print-font-16 text-center' style={{width:'100px'}}>จำนวนเงิน</td>
            </tr>
        	{this.renderRowData()}
        	{this.renderFooter()}
        	{this.renderSignature()}
          {doc==='purchase_received_doc'?this.renderSignatureDate():''}
          </tbody>  
        </table>
      </div>
    )      
  }

  renderHeader() {
    let {data} = this.state
    let {doc} = this.props
    let title = 'เลขประจำตัวผู้เสียภาษีอากร'
    if(this.props.doc==='cashbill_doc'){
      if(data.customer_name.indexOf('บริษัท')>=0 || data.customer_name.indexOf('บจก')>=0){
        title = ''
      }else{
        title = 'เลขบัตรประชาชน'
      }
    }    
    return(
      	<div style={{width:'100%'}}>
      		<div style={{float:'left',width:'74%',border:'1px solid #111',marginBottom:'5px',height:(doc==='purchase_received_doc'?'100px':'85px')}}>
	          <table className='table table-header-print-po-received-doc' style={{marginBottom:'0'}}>
	            <tbody>
	              <tr>
	                <td colSpan={2} className='print-font-16'>{doc==='purchase_received_doc'?'ถึงร้าน':'ลูกค้า'} {data.customer_name===''||data.customer_name===undefined?'-':data.customer_name}&nbsp;&nbsp;&nbsp;{data.customer_branch!=''&&data.customer_branch!=null&&data.customer_branch!=undefined?'สาขาที่ '+data.customer_branch:''}</td>
	              </tr>
	              <tr>
	                <td colSpan={2} className='print-font-16'>ที่อยู่ {data.customer_address===''||data.customer_address===undefined?'-':data.customer_address}</td>
	              </tr>
	              <tr style={{display:doc==='purchase_received_doc'?'none':''}}>                  
	                <td colSpan={2} className='print-font-16'>{title} {data.customer_tax===''||data.customer_tax===undefined?'-':data.customer_tax}</td>
	              </tr>
                <tr style={{display:doc=='purchase_received_doc'?'':'none'}}>
                  <td style={{width:'40%'}} className='print-font-16'>ทะเบียน -</td>
                  <td style={{width:'40%'}} className='print-font-16'>รุ่นรถ -</td>
                </tr>
                <tr style={{display:doc=='purchase_received_doc'?'':'none'}}>
                  <td className='print-font-16'>เลขคัซซี -</td>
                  <td className='print-font-16'>ประกัน -</td>
                </tr>
	            </tbody>
	          </table>
	        </div>
	        <div style={{float:'right',width:'25%',border:'1px solid #111',marginBottom:'5px',height:(doc==='purchase_received_doc'?'100px':'85px')}}>
	          <table className='table table-header-print-po-received-doc' style={{marginBottom:'0'}}>
	            <tbody>
	              <tr>
	                <td className='print-font-16' style={{width:'100px'}}>เลขที่</td>
	                <td className='print-font-16'>{(doc==='purchase_received_doc'?(data.meta===undefined||data.meta.purchase_order_no===''?'-':data.meta.purchase_order_no):(data.doc_no===''||data.doc_no===undefined?'-':data.doc_no))}</td>
	              </tr>
	              <tr>
	                <td className='print-font-16' style={{width:'100px'}}>วัน/เดือน/ปี</td>
	                <td className='print-font-16'>{(doc==='purchase_received_doc'?(data.meta===undefined||data.meta.added_date===''?'-':'-'):(data.doc_date===''||data.doc_date===undefined?'-':data.doc_date))}</td>
	              </tr>
	            </tbody>
	          </table>
	        </div>  
      	</div>
    )
  }

  renderComponentPage(item,index,total) {
    let {data,defaultTypePrint} = this.state

    return(
    	<div className='font-print' style={{width:'100%'}}>
    		<div style={{float:'left',width:'50%',display:defaultTypePrint==='2'?'none':''}} className={defaultTypePrint==='0'||defaultTypePrint==='3'?'hr-two-page-left':''}>
		      	<div>
		          <header>
		            <h2>{this.props.title}</h2>
		          </header>
		          <article className={"article-company "+data.logo_class}>
		            <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
		              {this.renderLogoUrl(data.logo_url)}
		            </div>
		            <section className="font-16" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
			            <strong>
			              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
			              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
			              <p style={{lineHeight:'0.7'}}>{this.company_tax!==''?('เลขประจำตัวผู้เสียภาษีอากร '+data.company_tax):''} โทร {data.company_tel}</p>
			            </strong>
		          	</section>
		          	<section className='text-center sec-copy-doc'>
			        	  <span style={{display:defaultTypePrint==='0'?'none':''}}>ต้นฉบับ</span>
		          	</section>
		          </article>
		        </div>
		        <div className="font-16">
		          {this.renderHeader()}
		          {this.renderTable()}
		        </div>
		    </div>
		    <div style={{float:'right',width:'50%',display:defaultTypePrint==='1'?'none':''}} className={defaultTypePrint==='0'||defaultTypePrint==='3'?'hr-two-page-right':''}>
		      	<div className='font-print'>
		          <header>
		            <h2>{this.props.title}</h2>
		          </header>
		          <article className={"article-company "+data.logo_class}>
		            <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
		              {this.renderLogoUrl(data.logo_url)}
		            </div>
		            <section className="font-16" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
			            <strong>
			              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
			              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
                    <p style={{lineHeight:'0.7'}}>{this.company_tax!==''?('เลขประจำตัวผู้เสียภาษีอากร '+data.company_tax):''} โทร {data.company_tel}</p>			              
			            </strong>
		          	</section>
		          	<section className='text-center sec-copy-doc'>
			        	  <span style={{display:defaultTypePrint==='0'?'none':''}}>สำเนา</span>
		          	</section>
		          </article>
		        </div>
		        <div className="font-16">
		          {this.renderHeader()}
		          {this.renderTable()}
		        </div>
		    </div>   
    	</div>  
    )
  }

  getPagination(data) {
    return data
  }

  onTypePrintChange(e) {
  	this.setState({defaultTypePrint:e})
  }

  render() {
    let {loading} = this.state

    return(
      <PrintPreview 
      	size={'landscape'}
        loading={loading}
        leftBarTitle={this.props.title+' '+this.props.docNo}
        onTypePrintChange={this.onTypePrintChange.bind(this)}
        defaultTypePrint={this.state.defaultTypePrint}
      >
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}  

PrintTwoPagesDoc.defaultProps = {
  title: 'ใบแจ้งหนี้',  
  doc: 'invoice_doc',
  docNo: '',
  param: 'iv',
  mode: '1'
}
export default PrintTwoPagesDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintTwoPagesDoc.js